import { forwardRef, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Modal, ModalBody } from 'reactstrap';

const Export = ({
  data,
  fileName,
  filterByParam,
  filterText,
  filterIcon,
  statusFilter,
  setStatusFilter,
}) => {
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (modal === true) {
      setTimeout(() => setModal(false), 2000);
    }
  }, [modal]);

  const SettingsToggle = forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-toggle btn-trigger mr-lg-n1"
    >
      {children}
      <em className="icon ni ni-setting fs-22px" />
    </div>
  ));
  SettingsToggle.displayName = 'SettingsToggle';

  return filterByParam ? (
    <>
      <div className="dt-export-buttons d-flex align-center">
        <div className="dt-buttons btn-group flex-wrap">
          <Dropdown className="pr-0">
            <Dropdown.Toggle as={SettingsToggle} />
            <Dropdown.Menu
              size="sm"
              title=""
              className="link-list-opt no-bdr dropdown-menu"
            >
              {/* <Dropdown.Item onClick={() => exportExcel()}>
                <em className="icon ni ni-file-download fs-20px" />
                {i18n.t('DownloadXLS')}
              </Dropdown.Item> */}

              {filterByParam && (
                <Dropdown.Item onClick={() => setStatusFilter(!statusFilter)}>
                  <em className={`icon fs-20px ${filterIcon[statusFilter]}`} />
                  {filterText[statusFilter]}
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <Modal
        isOpen={modal}
        className="modal-dialog-centered text-center"
        size="sm"
      >
        <ModalBody className="text-center m-2">
          <h5>Copied to clipboard</h5>
        </ModalBody>
        <div className="p-3 bg-light">
          <div className="text-center">
            Copied {data.length} rows to clipboard
          </div>
        </div>
      </Modal>
    </>
  ) : null;
};

export default Export;
